import { Principal, Recipient } from '../../../data/types.generated';
import { ParticipantRole } from '../../../service/gen/esign';
import { getDisplayName } from '../../../utilities/MapESignModel';

/**
 * Converts recipients to principals.
 *
 * @param recipients array of Recipient[]
 * @returns array of Principal[]
 */
export const convertESignRecipientsToApprovers = (recipients: Recipient[]): Principal[] => {
    if (!recipients) {
        return [];
    }

    return recipients.map((recipient: Recipient): Principal => {
        if (!recipient) return;

        return {
            id: recipient.id || '',
            // If the recipient is external, we do not receive the first or last name.
            // In that situation, we should display the email.
            displayName: getDisplayName(recipient.fullName, recipient.email) ?? '',
            ...(recipient.role && { type: ParticipantRole[recipient.role.toUpperCase()] }),
        };
    });
};
